function hasInitialized({ state, output }) {
  if (state.get('app.loaded')) {
    output.true()
  } else {
    output.false()
  }
}

hasInitialized.outputs = ['true', 'false']
export default hasInitialized



// WEBPACK FOOTER //
// ./src/modules/app/actions/hasInitialized.js